import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'combineCustomersModal.title',
    defaultMessage: 'Combine Customers',
    id: '6fKnG8',
  },
  body: {
    description: 'combineCustomersModal.body',
    defaultMessage: 'The first customer will be the surviving customer. Other customers will be absorbed by the surviving customer.',
    id: 'aSJVin',
  },
  cancel: {
    description: 'combineCustomersModal.cancel',
    defaultMessage: 'Cancel',
    id: 'wRqE7X',
  },
  combine: {
    description: 'combineCustomersModal.combine',
    defaultMessage: 'Combine',
    id: 'k9fe44',
  },
});

export default messages;
